import { SwiperSlide } from 'swiper/react'
import { A11y, Pagination } from 'swiper/modules'
import { MenuItemType } from '@utils/types'
import { BrandCard } from '@components/molecules'
import { GenericSection, GenericSlider } from '@components/organisms'
import styles from './BrandsSection.module.sass'
import useTrans from '@hooks/useTrans'

interface Props {
  brands?: any[] // TODO BrandNode[]
  item?: MenuItemType
  theme?: 'white' | 'neutral10'
  editMode?: boolean
  className?: string
}

const BrandsSection = (props: Props) => {
  const {
    brands = [],
    item = undefined,
    theme = 'neutral10',
    editMode = false,
    className = '',
  } = props

  const t = useTrans()

  return brands?.length || editMode ? (
    <GenericSection
    item={{
      ...(item || {}),
      name: item?.name ?? t('Scopri gli altri brand del gruppo'),
    }}
      theme={theme}
      editMode={editMode}
      className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}
    >
      {brands?.length && (
        <GenericSlider
          id="brand-list"
          conf={{
            slidesPerView: 1.5,
            spaceBetween: 20,
            modules: [Pagination, A11y],
            pagination: { clickable: true },
            breakpoints: {
              575: {
                slidesPerView: 2.2,
              },
              991: {
                slidesPerView: brands?.length >= 6 ? 6 : brands?.length <= 4 ? 4 : 5,
              },
            },
          }}
          className={styles.slider}
        >
          {brands.map((x, index) => (
            <SwiperSlide key={index}>
              <BrandCard key={x.pk} brand={x} />
            </SwiperSlide>
          ))}
        </GenericSlider>
      )}
    </GenericSection>
  ) : (
    <></>
  )
}

export default BrandsSection
